export default __webpack_public_path__ + "static/media/ICON-REALTY.899ff6b0.webp";